import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { SEO } from "../components/site/SEO";
import { Hero } from "../components/site/Hero";
import { Clients, Collections, Quality } from "../components/site/Sections";
import { Reveal, Overline } from "../components/site/primitives";

export default function Home() {
  return (
    <>
      <SEO
        title="Emporium London | Decor, Tableware & Bespoke Gifting for Hospitality"
        description="Emporium London supplies refined decor, tableware, barware and bespoke gifting to hotel groups, restaurants and corporate clients — every piece customisable to your theme."
        path="/"
      />
      <main>
        <Hero />
        <Clients />

        <section aria-labelledby="brand-statement" className="relative z-10 px-6 md:px-12 lg:px-16 py-24 md:py-36 border-b border-black/10">
          <Reveal><Overline>What We Do</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 id="brand-statement" className="mt-8 font-serif font-light text-3xl sm:text-5xl lg:text-6xl leading-[1.12] tracking-tight max-w-5xl text-balance">
              We help restaurants, hotels &amp; businesses turn physical products into <span className="italic text-[var(--brass)]">powerful marketing</span>, <span className="italic text-[var(--brass)]">customer engagement</span> and <span className="italic text-[var(--brass)]">new revenue channels</span>.
            </h2>
          </Reveal>
        </section>

        <Collections />
        <Quality />

        <section aria-labelledby="home-cta" className="relative z-10 px-6 md:px-12 lg:px-16 py-24 md:py-32 border-t border-black/10 bg-[var(--bg-secondary)]">
          <div className="max-w-3xl">
            <Reveal><Overline>Start Your Order</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 id="home-cta" className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
                Ready to furnish every room with objects that carry your brand?
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 flex flex-wrap gap-4">
                <Link to="/products" data-testid="home-products-link" className="inline-flex items-center gap-2 bg-[var(--text-primary)] text-[var(--bg-primary)] px-8 h-14 font-mono text-[11px] tracking-[0.22em] uppercase hover:bg-[var(--brass)] transition-colors duration-500">
                  Browse Products <ArrowRight size={16} />
                </Link>
                <Link to="/contact" data-testid="home-contact-link" className="inline-flex items-center gap-2 border border-black/20 px-8 h-14 font-mono text-[11px] tracking-[0.22em] uppercase hover:bg-[var(--text-primary)] hover:text-[var(--bg-primary)] transition-colors duration-500">
                  Request a Selection
                </Link>
              </div>
            </Reveal>
          </div>
        </section>
      </main>
    </>
  );
}
